import React from 'react';

export const CalenderPagesConfig = [
  {
    auth: ['superadmin','admin','ContentCreator'],
    routes: [
      {
        path: '/Calender/overview/:page',
        component: React.lazy(() => import('./Pages/Pageoverview')),
      },
    ],
  },
  {
    auth: ['superadmin','admin','ContentCreator'],
    routes: [
      {
        path: '/Calender/Detail/:id',
        component: React.lazy(() => import('./Pages/PageDetail')),
      },
    ],
  },
  {
    auth: ['superadmin','admin','ContentCreator'],
    routes: [
      {
        path: '/Calender/Delete/:page/:deleteID',
        component: React.lazy(() => import('./Pages/Pageoverview')),
      },
    ],
  },
  {
    auth: ['superadmin','admin','ContentCreator'],
    routes: [
      {
        path: '/Calender/new/',
        component: React.lazy(() => import('./Pages/new')),
      },
    ],
  },
];
